import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getUserBalanceAPI } from '../apis/userBetsAPI.ts';
import { useCurrencyStore } from '../store';

type UserBalance = Awaited<ReturnType<typeof getUserBalanceAPI>>;

type UseUserBalanceQueryOptions = Omit<
  UseQueryOptions<UserBalance, Error, UserBalance, ['userBalance', number]>,
  'queryKey' | 'queryFn'
>;

export const useUserBalanceAPIQuery = (
  options?: UseUserBalanceQueryOptions
) => {
  const currencyId = useCurrencyStore(({ currency }) => currency.id);
  return useQuery({
    queryKey: ['userBalance', currencyId],
    queryFn: () =>
      getUserBalanceAPI({
        currency_id: currencyId,
      }),
    refetchInterval: 5000,
    ...options,
  });
};
